export default function Hero() {
  return (
    <section className="w-full">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6 pt-8 md:pt-12 pb-10 md:pb-14">
        {/* 顶部氛围条 */}
        <div className="flex items-center gap-3 mb-8 md:mb-10">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 text-secondary-900 px-3 py-1 text-xs font-medium">
            <span className="h-1.5 w-1.5 rounded-full bg-secondary-500 animate-pulse"></span>
            社区讨论 · 正在围观
          </span>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 text-accent-900 px-3 py-1 text-xs font-medium">
            <i className="ri-sparkling-line text-sm"></i> 每日热瓜不停更
          </span>
        </div>

        {/* 双栏文+图对开 */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
          {/* 左：文案 */}
          <div className="order-2 lg:order-1">
            <div className="inline-flex items-center gap-2 rounded-md bg-primary-100/70 text-primary-800 px-3 py-1.5 text-xs font-semibold tracking-widest mb-6">
              <i className="ri-map-pin-2-fill text-sm"></i>
              1黑料网 首页入口 · 一键直达
            </div>
            <h1 className="font-serif text-4xl md:text-6xl font-black text-foreground-950 leading-[1.08] tracking-tight">
              1黑料网
              <span className="block mt-2 text-primary-600">导航 &amp; 直达</span>
            </h1>
            <p className="mt-6 text-base md:text-lg leading-relaxed text-foreground-600 max-w-xl">
              这里是 1黑料网 的社区讨论首页。无论你是来找<b className="text-foreground-900 font-semibold">最新地址</b>、
              蹲<b className="text-foreground-900 font-semibold">直达入口</b>，还是想一头扎进<b className="text-foreground-900 font-semibold">瓜田热聊</b>，
              从这里出发都能快速到达，不错过任何一场热闹。
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a
                href="#feed"
                className="whitespace-nowrap inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 text-background-50 px-6 py-3.5 text-sm md:text-base font-semibold hover:bg-primary-600 transition-colors cursor-pointer"
              >
                <i className="ri-login-circle-line text-lg"></i>
                进入 1黑料网 首页
              </a>
              <a
                href="#boards"
                onClick={(e) => e.preventDefault()}
                className="whitespace-nowrap inline-flex items-center justify-center gap-2 rounded-md border border-background-300/70 bg-background-50 text-foreground-800 px-6 py-3.5 text-sm md:text-base font-medium hover:border-primary-300 hover:text-primary-700 transition-colors cursor-pointer"
              >
                <i className="ri-bookmark-line text-lg"></i>
                收藏最新地址
              </a>
            </div>

            {/* 关键词自然分布 */}
            <div className="mt-8 flex flex-wrap gap-2">
              {["1黑料网导航", "1黑料网入口", "1黑料网直达", "1黑料网地址", "吃瓜讨论"].map((t) => (
                <a
                  key={t}
                  href="#"
                  onClick={(e) => e.preventDefault()}
                  className="inline-flex items-center gap-1.5 rounded-full border border-background-300/70 bg-background-50 px-3.5 py-1.5 text-xs text-foreground-600 hover:border-secondary-400 hover:text-secondary-800 hover:bg-secondary-50 transition-colors cursor-pointer"
                >
                  <i className="ri-hashtag text-[13px]"></i>
                  {t}
                </a>
              ))}
            </div>

            <div className="mt-8 flex items-center gap-6 text-xs text-foreground-500">
              <div className="flex items-center gap-1.5">
                <i className="ri-user-heart-line text-base text-primary-500"></i>
                <span><b className="text-foreground-900 font-semibold">12.4w</b> 位瓜友在线</span>
              </div>
              <div className="flex items-center gap-1.5">
                <i className="ri-chat-3-line text-base text-accent-600"></i>
                <span>今日新增 <b className="text-foreground-900 font-semibold">3.8w</b> 条讨论</span>
              </div>
            </div>
          </div>

          {/* 右：图对开 */}
          <div className="order-1 lg:order-2">
            <div className="relative">
              <div className="absolute -inset-3 rounded-2xl bg-gradient-to-tr from-primary-100 via-background-100 to-secondary-100"></div>
              <div className="relative overflow-hidden rounded-2xl border border-background-200/70 bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20warm%20ivory%20editorial%20magazine%20collage%20illustration%20of%20a%20crowd%20of%20diverse%20people%20gathered%20around%20a%20central%20glowing%20newspaper%2C%20chattering%20with%20floating%20speech%20bubbles%20and%20comment%20boxes%2C%20community%20gossip%20discussion%20atmosphere%2C%20flat%20vector%20style%20with%20burnt%20orange%20deep%20red%20and%20warm%20amber%20palette%2C%20soft%20paper%20grain%20texture%2C%20dramatic%20spotlight%20and%20long%20soft%20shadows%2C%20premium%20editorial%20layout%2C%20no%20text%2C%20no%20words&width=1000&height=1120&seq=hm-hero-main&orientation=portrait"
                  alt="1黑料网导航入口与社区讨论氛围插画"
                  title="1黑料网 导航入口"
                  className="w-full aspect-[10/11] object-cover object-top"
                />
              </div>

              {/* 漂浮状态卡：找地址 */}
              <div className="absolute -left-3 md:-left-5 top-6 rounded-xl border border-background-200/70 bg-background-50/95 p-3 shadow-none backdrop-blur">
                <p className="flex items-center gap-1.5 text-xs font-semibold text-foreground-900">
                  <i className="ri-checkbox-circle-fill text-sm text-accent-500"></i> 最新地址已更新
                </p>
                <p className="mt-1 text-[11px] text-foreground-500">1黑料网 首页入口可用 · 直达链接正常</p>
              </div>

              {/* 漂浮状态卡：热评 */}
              <div className="absolute -right-2 md:-right-4 bottom-6 max-w-[210px] rounded-xl border border-background-200/70 bg-background-50/95 p-3.5 backdrop-blur">
                <div className="flex items-center gap-2">
                  <span className="grid place-items-center h-7 w-7 rounded-full bg-primary-500 text-background-50 text-xs font-bold">热</span>
                  <p className="text-xs text-foreground-700 leading-snug">「今晚这个瓜有反转，蹲个后续」</p>
                </div>
                <p className="mt-2 flex items-center gap-1 text-[11px] text-accent-600">
                  <i className="ri-fire-fill text-xs"></i> 热议中 · 2.3k 人参与
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}